import { Injectable } from "@angular/core";
import { DataService } from "../DataService/data.service";
import { Observable, of } from "rxjs";
import { APIName } from "../../Models/APIEndPoints/APIName";
import { ISocialMediaLinks } from "src/app/Models/Interface/SocialMediaLinks/social-media-links";

@Injectable({
  providedIn: "root",
})
export class SocialMediaLinksService {
  constructor(private dataService: DataService) {}

  getSocialMediaLinks(): Observable<ISocialMediaLinks[]> {
    let socialMediaLinks: ISocialMediaLinks[] = [];
    if (localStorage.getItem("socialMediaLinks")) {
      socialMediaLinks = JSON.parse(localStorage.getItem("socialMediaLinks")!);
      return of(socialMediaLinks);
    }
    return this.dataService.get(APIName.socialMediaLinks);
  }
}
